import { validateEmail } from '../inputs-validators';

export const getPhone = (phone: string) => {
    return String(phone).replace(/[ ()]/g, '').replaceAll('-', '').replaceAll(' ', '').replace('+7', '');
};

export const checkUndefinedString = (value: string | null) => {
    if (value === 'undefined') {
        return '';
    }

    return String(value || '');
};

export const getLegalName = (legalName: FormDataEntryValue, shortName?: string) => {
    if (legalName && shortName) {
        return shortName + ' ' + String(legalName);
    }
    return String(legalName);
};

export const getEmail = (email: string) => {
    if (validateEmail(email)) {
        return email;
    }
    return '';
};

export const getIdProp = (agentPartyId?: string, referralCode?: string) => {
    if (agentPartyId) {
        return { agentPartyId, referralCode: '' };
    }

    if (referralCode) {
        return { referralCode, agentPartyId: '' };
    }
    return { referralCode: '', agentPartyId: '' };
};
